module.exports = __webpack_public_path__ + "static/media/simfoni_text_127x47.c9be69bd.png";